/*!

=========================================================
* Paper Dashboard React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

const Footer = ({ color = "black", text = "Default Footer Text" }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="credits ml-auto" style={{ width: "100%" }}>
          <div className="copyright" style={{ width: "100%", textAlign: "center", fontSize: "16px" }}>
            If you have trouble submitting the form, please contact us.
            <br />
            Phone number: <a href="tel:+48536174876" style={{ color: "#007bff" }}>+48 536 174 876</a> Email: <a href="mailto:office_de@slampoland.pl" style={{ color: "#007bff" }}>office_de@slampoland.pl</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
